export default "/images/vendor/@coreui/icons/svg/flag/cif-ad.svg?14de6fe8a15dbe6a2da132738f7145fa";